export const OLLAMA_URL =
  process.env.REACT_APP_OLLAMA_URL ||
  'https://unashamed-monkhood-penholder.ngrok-free.dev';

export const API_URL =
  process.env.REACT_APP_API_URL || 'https://coder.kvtech.net/api';

export const MODEL = 'Professor-Raimal:latest';
export const APP_NAME = 'CoderAI';
export const APP_TAGLINE = 'Your free AI coding & text assistant';